export interface ExportCategoriesI {
  label: string;
  value: string;
  selected: boolean;
  disabled?: boolean;
}

export const applyPreferences = (
  initial: ExportCategoriesI[],
  prefs: string[] | undefined,
) => {
  return prefs
    ? initial.map((c) => ({
        ...c,
        selected: c.disabled || prefs.indexOf(c.value) >= 0,
      }))
    : initial;
};
